<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.polls', 2),
                        href: meta.links.polls_index,
                    },
                    {
                        name: smileyPollQuestion.question,
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                ></th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <img
                                        class="inline-block h-6 w-6"
                                        src="/svg/smiley-poll/smiley-1.svg"
                                        alt="Smiley"
                                    />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <img
                                        class="inline-block h-6 w-6"
                                        src="/svg/smiley-poll/smiley-2.svg"
                                        alt="Smiley"
                                    />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <img
                                        class="inline-block h-6 w-6"
                                        src="/svg/smiley-poll/smiley-3.svg"
                                        alt="Smiley"
                                    />
                                </th>
                                <th
                                    class="px-2 py-3 bg-gray-50 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <img
                                        class="inline-block h-6 w-6"
                                        src="/svg/smiley-poll/smiley-4.svg"
                                        alt="Smiley"
                                    />
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(smileyPollResult, index) in smileyPollResults"
                                :key="smileyPollResult.id"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    <AppButton desired-action :href="smileyPollResult.links.show">
                                        {{ smileyPollResult.name }}
                                    </AppButton>
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    {{ smileyPollResult.option_1.votes }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    {{ smileyPollResult.option_2.votes }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    {{ smileyPollResult.option_3.votes }}
                                </td>
                                <td
                                    class="max-w-sm truncate px-2 py-2 whitespace-nowrap text-sm leading-5 font-medium text-gray-900 text-center"
                                >
                                    {{ smileyPollResult.option_4.votes }}
                                </td>
                                <td
                                    class="px-6 py-2 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    {{ smileyPollResult.created_at }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="mt-5 flex justify-center" v-if="total.totalVotes">
            <SmileyPoll :input-question="smileyPollQuestion.question" :input-results="total" />
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import SmileyPoll from '@/components/pageSpecific/SmileyPoll.vue';

export default {
    components: {
        PanelPage,
        AppButton,
        SmileyPoll,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'smileyPollResults', 'smileyPollQuestion', 'total'],
};
</script>
